import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import useTableChecked from "../../useTableChecked";
import { formatMoneda } from "../../../util/varios";
import moment from "moment";

export const ModalAgregarDeudaPublicidad = (props) => {
    let op = require('../../../modulos/datos');
    const token = JSON.parse(sessionStorage.getItem("jwtToken"));
    const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
    const accdeudamina = JSON.parse(sessionStorage.getItem("accdeudamina"));
    const [desde, setDesde] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [deuda, setDeuda] = useState([]);
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [agente, setAgente] = useState({
        idinmueble: "",
        razonsocial: "",
        rif: "",
        direccion: "",
        idtipoaseo: "",
        credito: 0.0,
    });
    const fechaPagoRef = useRef(null);
    const numFacturaRef = useRef(null);
    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });
    const [selected, setSelected] = useState([]);

    const headCells = [
        {
            id: "0",
            backgroundColor: "#3b8eed",
            color: "#ffffff",
            label: "TIPO",
            textAlign: "center",
            disableSorting: false,
        },
        {
            id: "1",
            backgroundColor: "#3b8eed",
            color: "#ffffff",
            label: "AÑO",
            textAlign: "center",
            disableSorting: false,
        },
        {
            id: "2",
            backgroundColor: "#3b8eed",
            color: "#ffffff",
            label: "MES",
            textAlign: "center",
            disableSorting: false,
        },
        {
            id: "3",
            backgroundColor: "#3b8eed",
            color: "#ffffff",
            label: "CONCEPTO",
            textAlign: "center",
            disableSorting: false,
        },
        {
            id: "4",
            backgroundColor: "#3b8eed",
            color: "#ffffff",
            label: "MONTO",
            textAlign: "center",
            disableSorting: false,
        },
        {
            id: "5",
            backgroundColor: "#3b8eed",
            color: "#ffffff",
            label: "INTERES MORA",
            textAlign: "center",
            disableSorting: false,
        },
        {
            id: "6",
            backgroundColor: "#3b8eed",
            color: "#ffffff",
            label: "RECARGOS",
            textAlign: "center",
            disableSorting: false,
        },
        {
            id: "7",
            backgroundColor: "#3b8eed",
            color: "#ffffff",
            label: "TOTAL",
            textAlign: "center",
            disableSorting: false,
        },
    ];

    const {
        TblContainer,
        EnhancedTableHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    } = useTableChecked(deuda, headCells, filterFn);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setSelected(deuda);
            return;
        } else {
            setSelected([]);
        }
    };

    const handleClick = (row) => {
        const selectedIndex = selected.indexOf(row);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };

    const handleSearch = (e) => {
        let target = e.target;

        setFilterFn({
            fn: (items) => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter((x) => {
                        if (
                            TIPODEUDA[x.tipodeuda]
                                .toString()
                                .toLowerCase()
                                .includes(target.value.toLowerCase()) ||
                            x.anio
                                .toString()
                                .toLowerCase()
                                .includes(target.value.toLowerCase()) ||
                            x.mes
                                .toString()
                                .toLowerCase()
                                .includes(target.value.toLowerCase()) ||
                            x.concepto
                                .toString()
                                .toLowerCase()
                                .includes(target.value.toLowerCase())
                        ) {
                            return x;
                        }
                    });
                }
            },
        });
    };

    const blanquear = () => {
        setOperacion(0);
        setDeuda([]);
        setAgente({
            idinmueble: "",
            razonsocial: "",
            rif: "",
            direccion: "",
            idtipoaseo: "",
            credito: 0.0,
        });
    };


    const cancelar = () => {
        blanquear();
        props.onHide();
    };

    useEffect(() => {
        if (operacion !== 0) {
            if (selected.length > 0) {
            } else if (operacion === 1) {
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "Debe Seleccionar La Deuda",
                    icono: "informacion",
                });
                setOperacion(0);
            }
        } else {
        }
    }, [operacion]);

    const gestionar = (n) => {

        setOperacion(n);
    };

    const aceptar = () => {
        var sigue = true;
        let declaweb = props.config.declaracionweb;
        let periodo = 1;
        let nomTabla = "publicidad";
        let nomIdContri = "";
        let nomIdDeuda = "idpublicidad";
        

        if (fechaPagoRef.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el la Fecha de pago.', icono: 'informacion' });
            sigue = false;
            fechaPagoRef.current.focus();
        } else if (numFacturaRef.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el Numero de la Factura.', icono: 'informacion' });
            sigue = false;
            numFacturaRef.current.focus();
        } 
        if (sigue) {

            let body = {
                id: parseInt(props.deuda.idpublicidad),
                nomtab: nomTabla,
                nomid: nomIdDeuda,
                monto: props.deuda.monto,
                declaweb: declaweb,
                idusu: JSON.parse(localStorage.getItem("idusuario")),
                fechasis: JSON.parse(localStorage.getItem("fechasistema")),
                fechareal: JSON.parse(localStorage.getItem("fechareal")),
                fechapago: fechaPagoRef.current.value,
                numrecibo: numFacturaRef.current.value,
                nanio: parseInt(props.deuda.anio),
            };
            ///alert(JSON.stringify(body))
            actualizarDeuda(body);
        }
    };

    const actualizarDeuda = (body) => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/comun/actudeudapublicidadlicores`;
        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (response.data) {
                        setActivate(false);
                        setDesde(1);
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto:"La Deuda ha sido Actualizada de manera satisfactoria.",
                            icono: "informacion",
                        });

                    }
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        setDesde(0);
        props.onHideAcepta();
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                //alert(JSON.stringify(props.deuda))
                fechaPagoRef.current.value = moment.utc(props.fechaSistema).format("YYYY-MM-DD");
            }}
        >
            <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top text-light">
                <h3 className="my-auto">Actualizar Deuda Publicidad</h3>
                <a type='button'
                    className="fw-bold text-light fs-6"
                    onClick={cancelar}
                >
                    Salir <i className="fa fa-times ms-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid rounded p-0 my-0">

                    <fieldset className="row border-azul rounded mx-auto col-sm-12">
                        <legend className="float-none m-0 w-auto">
                            Detalle Deuda Contribuyente Publicidad Comercial
                        </legend>
                        <div class="input-group input-group-sm mb-1 px-0 col-md-5">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Codigo:</span>
                            <input type="text" disabled class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? props.deuda.idtipopublicidad : ''} />
                            <button
                                type="button"
                                className="fw-bold btn btn-primary btn-sm" disabled
                            >
                                <i class="fas fa-search"></i>
                            </button>
                        </div>

                        <div class="input-group input-group-sm mb-1 px-0 col-md-7">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Cod. Segun Ordenanza</span>
                            <input type="text" disabled class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? props.deuda.codigoordenanza : ''} />
                        </div>
                        <div class="input-group input-group-sm mb-1 col-md-12 px-0">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Descripcion:</span>
                            <textarea type="textarea" disabled style={{ height: 70 }} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? props.deuda.descripcion : ''}/>
                        </div>
                        <div class="input-group input-group-sm mb-1 px-0 col-md-5 ml-0">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Fecha:</span>
                            <input type="date" disabled class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? moment.utc(props.deuda.fechainscripcion).format("YYYY-MM-DD") : ''}/>
                        </div>

                        <fieldset className="row border-azul rounded mx-auto col-sm-12 mb-1">
                            <legend className="float-none m-0 w-auto">
                                Unidad de Medida
                            </legend>
                            <div class="input-group input-group-sm mb-1 px-0 col-md-6">
                                <span class="input-group-text" id="inputGroup-sizing-sm">Ancho:</span>
                                <input type="text" disabled class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? formatMoneda(props.deuda.ancho.toString().replace(".", ","), ",", ".", 2) : ''} />
                            </div>

                            <div class="input-group input-group-sm mb-1 px-0 col-md-6">
                                <span class="input-group-text" id="inputGroup-sizing-sm">Alto:</span>
                                <input type="text" disabled class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? formatMoneda(props.deuda.alto.toString().replace(".", ","), ",", ".", 2) : ''} />
                            </div>
                            <div class="input-group input-group-sm mb-1 col-md-6 px-0 ml-0">
                                <span class="input-group-text" id="inputGroup-sizing-sm">Total Metros Cuadrados:</span>
                                <input type="text" disabled class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? formatMoneda(props.deuda.cantidad.toString().replace(".", ","), ",", ".", 2) : ''}/>
                            </div>

                        </fieldset>

                        <div class="input-group input-group-sm mb-1 px-0 col-md-6">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Valor Unitario:</span>
                            <input type="text" disabled class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? formatMoneda((props.deuda.monto/props.deuda.cantidad).toString().replace(".", ","), ",", ".", 2) : ''} />
                        </div>

                        <div class="input-group input-group-sm mb-1 px-0 col-md-6">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Valor Total:</span>
                            <input type="text" disabled class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? formatMoneda(props.deuda.monto.toString().replace(".", ","), ",", ".", 2) : ''}/>
                        </div>

                        <fieldset className="row border-azul rounded mx-auto col-sm-12 mb-1">
                            <legend className="float-none m-0 w-auto">
                                Copias de Recaudo
                            </legend>
                            <div class="form-check col-md-6">
                                <input class="form-check-input" type="checkbox" disabled defaultChecked={props.deuda ? props.deuda.reccroquisubi : false} id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Croquis de Ubicación
                                </label>
                            </div>
                            <div class="form-check col-md-6">
                                <input class="form-check-input" disabled type="checkbox" defaultChecked={props.deuda ? props.deuda.recplanoestructura : false} id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Plano de la Estructura
                                </label>
                            </div>
                            <div class="form-check col-md-6">
                                <input class="form-check-input" disabled type="checkbox" defaultChecked={props.deuda ? props.deuda.recautpropieinmue : false} id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Aut. Propiedad Inm.
                                </label>
                            </div>
                            <div class="form-check col-md-6">
                                <input class="form-check-input" disabled type="checkbox" defaultChecked={props.deuda ? props.deuda.recautinsvialreg : false} id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Autorizacion Ins. Vial
                                </label>
                            </div>
                            <div class="form-check col-md-6">
                                <input class="form-check-input" disabled type="checkbox" defaultChecked={props.deuda ? props.deuda.recusoconfddu : false} id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Para que Uso
                                </label>
                            </div>
                            <div class="input-group input-group-sm mb-1 col-md-12 px-0 mt-2">
                                <span class="input-group-text" id="inputGroup-sizing-sm">Descripcion de Ubicación:</span>
                                <textarea type="textarea" disabled style={{ height: 70 }} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.deuda ? props.deuda.ubicacion : ''}/>
                            </div>

                        </fieldset>

                        <div class="input-group input-group-sm mb-1 px-0 col-md-6">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Fecha de Pago:</span>
                            <input type="date" ref={fechaPagoRef} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>

                        <div class="input-group input-group-sm mb-1 px-0 col-md-6">
                            <span class="input-group-text" id="inputGroup-sizing-sm">N° Factura:</span>
                            <input type="text" ref={numFacturaRef} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>


                    </fieldset>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row col-md-12">

                    <button
                        type="button"
                        style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
                        className="col-md-3 fw-bold btn btn-success btn-sm rounded-pill"
                        onClick={aceptar}
                    >
                        <i class="fas fa-check-circle"></i> Aceptar
                    </button>
                    <button
                        type="button"
                        style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
                        className="col-md-3 fw-bold btn btn-danger btn-sm rounded-pill"
                        onClick={cancelar}
                    >
                        <i className="fas fa-trash"></i> Cancelar
                    </button>
                </div>
            </Modal.Footer>
            <Dimmer active={activate} />
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === "Exito."
                        ? cerrarModal()
                        : setMensaje({
                            mostrar: false,
                            titulo: "",
                            texto: "",
                            icono: "",
                        });
                }}
            />

        </Modal>
    );
};
